module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7d3dd7098c7f0f16ebd370cfeb1161e9.png";